export function groupWhile(predicate, items) {
    if (items.length === 0)
        return [];
    const [, grouped] = items.reduce(([prev, groups], item) => {
        if (!prev) {
            return [item, [[item]]];
        }
        if (predicate(prev, item)) {
            const lastGroup = groups[groups.length - 1];
            lastGroup.push(item);
            return [item, groups];
        }
        else {
            groups.push([item]);
            return [item, groups];
        }
    }, [undefined, [[]]]);
    return grouped;
}
export function groupBy(items, keySelector) {
    const grouped = new Map();
    for (const item of items) {
        const key = keySelector(item);
        const existing = grouped.get(key);
        if (existing !== undefined) {
            existing.push(item);
        }
        else {
            grouped.set(key, [item]);
        }
    }
    return grouped;
}
export function flatMap(things, fn) {
    return things.reduce((agg, thing) => {
        agg.push(...fn(thing));
        return agg;
    }, []);
}
export function distinctBy(things, keyFn) {
    if (things.length == 0)
        return things;
    const set = new Set();
    const output = [];
    for (const thing of things) {
        const key = keyFn(thing);
        if (!set.has(key)) {
            set.add(key);
            output.push(thing);
        }
    }
    return output;
}
export function zip(a, b) {
    const l = Math.min(a.length, b.length);
    const res = [];
    for (let i = 0; i < l; i++) {
        res.push([a[i], b[i]]);
    }
    return res;
}
export function chunk(array, size) {
    const chunkCount = Math.floor((array.length - 1) / size) + 1;
    const chunks = [];
    for (let chunkIndex = 0; chunkIndex < chunkCount; chunkIndex++) {
        const start = chunkIndex * size;
        const end = start + size;
        chunks.push(array.slice(start, end));
    }
    return chunks;
}
export function toRecord(xs, keyFn) {
    return toRecord2(xs, keyFn, (x) => x);
}
export function toRecord2(xs, keyFn, valFn) {
    return toRecordFiltered(xs, keyFn, valFn, (_) => true);
}
export function toRecordFiltered(xs, keyFn, valueFn, filterFn) {
    return xs.reduce((rec, x) => {
        if (filterFn(x)) {
            rec[keyFn(x)] = valueFn(x);
        }
        return rec;
    }, {});
}
export function keepMax(items, keep, max) {
    let i = items.length;
    while (i--) {
        if (items.length <= max) {
            break;
        }
        if (!keep(items[i])) {
            items.splice(i, 1);
        }
    }
}
export function partition(items, fn) {
    return items.reduce(([yes, no], thing) => {
        if (fn(thing)) {
            yes.push(thing);
        }
        else {
            no.push(thing);
        }
        return [yes, no];
    }, [[], []]);
}
